import { btnStyle, palette } from '@bingads-webui-campaign/shared-image-experience-styles';

export const getEditVideoStyle = () => ({
  root: {
    '& .edit-video-container': {
      marginTop: 20,
      paddingBottom: 45,
      '& .ms-Pivot-link[disabled] .ms-Pivot-text': {
        color: 'rgba(0, 0, 0, 0.55)',
      },
      '& .edit-video-description': {
        marginTop: 20,
        marginBottom: 35,
      },
      '& .description': {
        marginTop: 16,
        marginBottom: 30,
      },
      '& .title': {
        fontSize: 14,
        fontWeight: 600,
      },
      '& .edit-container': {
        '& .thumbnail-edit-container': {
          '& .select-image-button': {
            marginTop: 10,
          },
          '& .thumbnail-candidate img': {
            marginTop: 10,
            border: '3px solid rgb(0, 120, 212)',
          },
        },
        '& .file-picker-react-wrapper': {
          margin: 0,
          padding: '14px 0 0 0',
          width: '100%',
          '& .file-picker-btn': {
            extend: btnStyle()['.btn-default'],
            display: 'inline-block',
            float: 'none',
            marginLeft: 0,
          },
        },
      },
      '& .edit-container.caption-editor': {
        width: 700,
        marginTop: 20,
        '& .react-block-ui': {
          height: '100%',
        },
        '& .caption-container': {
          marginTop: 10,
          '& .ms-Spinner': {
            display: 'inline-flex',
            marginTop: 20,
          },
        },
        '& .upload-caption-file-container': {
          display: 'flex',
          marginTop: 10,
          '& .file-picker-react-wrapper': {
            marginLeft: 8,
            padding: 0,
          },
        },
      },
      '& .preview-container': {
        marginLeft: 24,
        marginTop: 20,
        '& .thumbnail-preview-container': {
          display: 'flex',
          width: 950,
          marginBottom: 20,
          '& .thumbnail-preview': {
            backgroundColor: 'black',
          },
        },
        '& .preview-unavailable': {
          fontSize: 14,
          marginBottom: 20,
        },
        '& .thumbnail-cropper-container': {
          marginBottom: 20,
        },
        '& .thumbnail-cropper-container .react-image-cropper': {
          margin: 0,
        },
      },
      '& .cropper-editor.crop-container, & .clipper-editor.clip-container': {
        marginLeft: 10,
        display: 'flex',
        justifyContent: 'center',
      },
      '& .cropper-editor.crop-container': {
        '& > div > div:nth-child(2), & > div > div:nth-child(2) + div': {
          background: 'black',
          color: 'white',
          '& i': {
            marginTop: 12,
            marginBottom: 12,
          },
          '& i:first-child': {
            marginLeft: 16,
          },
          '& i:last-child': {
            marginRight: 16,
          },
          '& .ms-Slider-container': {
            marginLeft: 16,
            marginRight: 16,
          },
        },
      },
      '& div[role="tablist"]': {
        marginBottom: '15px',
        '& .ms-Pivot-link': {
          padding: 0,
        },
        '& button': {
          height: 40,
          width: 120,
          background: '#F3F2F1',
          '& .ms-Pivot-text': {
            color: palette.neutralPrimary,
          },
          '&:hover': {
            background: '#EDEBE9',
          },
        },
        '& button.is-selected': {
          background: '#EFF6FC',
          '& .ms-Pivot-text': {
            color: palette.neutralPrimary,
            fontWeight: 600,
          },
          '&:hover': {
            background: '#C7E0F4',
          },
        },
      },
    },
    '& .error': {
      color: '#A80000',
      fontSize: 12,
      margin: '4px 0 0 0',
    },
    '& .footer-container': {
      display: 'flex',
      '& .ms-Button': {
        borderRadius: '2px',
        marginRight: 12,
      },
      '& .apply-to-all': {
        position: 'absolute',
        bottom: 65,
        paddingLeft: 1,
        paddingBottom: 10,
        width: '96%',
        background: 'rgba(255, 255, 255, 1)',
      },
    },
    '& .ms-Panel-commands': {
      zIndex: 10,
    },
    '& .ms-Panel-footer': {
      borderTop: '1px solid #EDEBE9',
      background: 'rgba(255, 255, 255, 1)',
      '& .ms-Panel-footerInner': {
        padding: '16px 0px',
        '& button:first-child': {
          marginLeft: 24,
        },
        '& .apply-to-all': {
          paddingLeft: 25,
        },
      },
    },
    '& .ms-ChoiceField-wrapper label': {
      padding: 0,
      '& .ms-ChoiceFieldLabel': {
        fontWeight: 400,
      },
    },
  },
});
